"use client";

import type { ReactNode } from "react";

/**
 * Centered content layout for recording/processing states.
 * Used by VoiceChangerV2, VoiceIsolatorV2, etc.
 */
export function CenteredLayout({ children, footer }: { children: ReactNode; footer: ReactNode }) {
  return (
    <div className='tw-flex tw-size-full tw-flex-1 tw-flex-col tw-mt-3'>
      <div className='tw-flex tw-flex-col tw-items-center tw-flex-1 tw-justify-center tw-gap-4'>{children}</div>
      <div className='tw-flex tw-items-center tw-justify-center tw-h-20'>{footer}</div>
    </div>
  );
}
